module.exports = __webpack_public_path__ + "img/icb.f8b6b22f.jpg";